const MemoryCache = {
  data: {},
  set(key, value, maxAge) {
    // Save data
    this.data[key] = {
      maxAge: maxAge || 0,
      value,
      now: Date.now(),
    };
    //console.log("Sparat till cache " + key);
  },
  get(key) {
    // Retrieves the value of the specified key from the cache.
    const cachedItem = this.data[key];
    if (!cachedItem) return null;
    const isExpired = Date.now() - cachedItem.now > cachedItem.maxAge;
    isExpired && this.delete(key);
    return isExpired ? null : cachedItem.value;
  },
  delete(key) {
    // Remove the value of the specified key from the cache.
    return delete this.data[key];
  },
  clear() {
    // Clear the cached data.
    this.data = {};
  },
};

function generateReqKey(config) {
  const { method, url, params, data } = config;
  return [method, url].join("&");
}

function isCacheLike(cache) {
  return (
    cache.set &&
    cache.get &&
    cache.delete &&
    cache.clear &&
    typeof cache.get === "function" &&
    typeof cache.set === "function" &&
    typeof cache.delete === "function" &&
    typeof cache.clear === "function"
  );
}

export default function cacheAdapterEnhancer(adapter, options) {
  const {
    maxAge,
    enabledByDefault = true,
    cacheFlag = "cache",
    defaultCache = MemoryCache,
  } = options;

  return (config) => {
    const { url, method, params, forceUpdate } = config;
    let useCache =
      config[cacheFlag] !== undefined && config[cacheFlag] !== null
        ? config[cacheFlag]
        : enabledByDefault;
    if (method === "get" && useCache) {
      const cache = isCacheLike(useCache) ? useCache : defaultCache;
      let requestKey = generateReqKey(config); // Generate the request Key
      let responsePromise = cache.get(requestKey); // Retrieve the response object corresponding to the request key from the cache
      if (!responsePromise || forceUpdate) {
        // If the cache is not hit/invalid or forced to update, the data is re-requested
        responsePromise = (async () => {
          try {
            return await adapter(config); // Use the default xhrAdapter to send requests
          } catch (reason) {
            cache.delete(requestKey);
            throw reason;
          }
        })();
        cache.set(requestKey, responsePromise, maxAge); // Save the response object returned by the request
        return responsePromise; // Returns the saved response object
      }
      //console.log("Hämtat från cache " + requestKey);
      return responsePromise;
    }
    return adapter(config); // Use the default xhrAdapter to send requests
  };
}
